export default (function($) {
  let $html,
      $body,
      $mobileNav,
      $mobileNavToggle,
      $mobileSubNavToggle;

  this.init = () => {
    this.setVars();
    this.modifyDOM();
    this.addEvents();
  };

  this.setVars = () => {
    $html                 = $('html');
    $body                 = $('body');
    $mobileNav            = $('.mobile-navigation');
    $mobileNavToggle      = $('.mobile-navigation-toggle');
    $mobileSubNavToggle   = $('.menu-item-has-children > a');
  };

  this.modifyDOM = () => {
  };

  this.addEvents = () => {
    $mobileNavToggle.on('click', this.eventHandlers.showMobileMenu);
    $mobileSubNavToggle.on('click', this.eventHandlers.showMobileSubMenu);
  };

  this.eventHandlers = {
    showMobileMenu() {
      return $mobileNavToggle.hasClass('active') === true ? $mobileNavToggle.removeClass('active') && $mobileNav.removeClass('mobile-navigation--collapsed') && $html.removeClass('mobile-navigation-open') : $mobileNavToggle.addClass('active') && $mobileNav.addClass('mobile-navigation--collapsed') && $html.addClass('mobile-navigation-open');
    },

    showMobileSubMenu(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).parent().toggleClass('collapsed').children('ul').toggle();
    }
  };

  this.helpers = {
  };

  return this.init;
}).call({}, jQuery);
